import { render, staticRenderFns } from "./UpdateImei.vue?vue&type=template&id=2f8442bf&scoped=true"
import script from "./UpdateImei.vue?vue&type=script&lang=js"
export * from "./UpdateImei.vue?vue&type=script&lang=js"
import style0 from "./UpdateImei.vue?vue&type=style&index=0&id=2f8442bf&prod&scoped=true&lang=css"
import style1 from "./UpdateImei.vue?vue&type=style&index=1&id=2f8442bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8442bf",
  null
  
)

export default component.exports